import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import LeadershipMessages from './components/LeadershipMessages';
import WhyLoveUs from './components/WhyLoveUs';
import HowToEnroll from './components/HowToEnroll';
import Teachers from './components/Teachers';
import PopularCourses from './components/PopularCourses';
import Testimonial from './components/Testimonial';
import Gallery from './components/Gallery';
import Kindergarten from './components/Kindergarten';
import Statistics from './components/Statistics';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <div className="App">
      <Header />
      <Hero />
      <LeadershipMessages />
      <Kindergarten />
      <WhyLoveUs />
      <HowToEnroll />
      <Teachers />
      <PopularCourses />
      <Testimonial />
      {/* <Gallery /> */}
      <Statistics />
      {/* <Blog /> */}
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
